import Model from '../../framework/model.js';
import Utils from '../../framework/utils.js';
import Globals from '../../framework/globals.js';

const defaults = {
  id: '',
  name: '',
  city: '',
  region: '',
  country: '',
  remote: false,
  latitude: '',
  longitude: ''
};

// JobLocationModel
// ================
//
// Fairly basic wrapper around a City. However, in order to maintain a semblence of Singleton for each city,
// we provide static constructors/accessors.

class JobLocationModel extends Model {
  constructor(data = {}) {
    super({data: data, defaults: defaults});
  }

  getLabel() {
    return this.get('name');
  }

  matchPost(post) {
    return post.get('jobLocation') == this;
  }
}
JobLocationModel.REMOTE_ID = '_remote';
JobLocationModel._all = [];
JobLocationModel._all.push(new JobLocationModel({ id: JobLocationModel.REMOTE_ID, name: 'Remote'}));

// `resolveLocationRegion(value)`
//
// Gets the location region title as defined in WordPress Taxonony "Location Regions".
// If the specified region value matches a Location Region's title or synonym, then return
// the matching Location Region's title. Otherwise, return the provided region value.
JobLocationModel.resolveLocationRegion = (value) => {
  for (let i = 0; i < window.careers_map.regions.length; i++) {
    let region = window.careers_map.regions[i];
    if (value === region.title) {
      return region.title;
    } else {
      for (let j = 0; j < region.synonyms.length; j++) {
        if (value === region.synonyms[j]) {
          return region.title;
        }
      }
    }
  }
  return value;
};


// Registers the provided job location, and returns it
JobLocationModel.registerJobLocation = (postLocation) => {
  if (postLocation.remote) {
    postLocation.id = JobLocationModel.REMOTE_ID;
    postLocation.name = 'Remote'
  } else {
    postLocation.region = JobLocationModel.resolveLocationRegion(postLocation.region);
    postLocation.country = postLocation.country.toUpperCase();
    postLocation.latitude = parseFloat(postLocation.latitude);
    postLocation.longitude = parseFloat(postLocation.longitude);
    
    let idParts = [postLocation.region, postLocation.city].filter(p => p);
    postLocation.id = Utils.slugify(idParts.join(' '));
    let nameParts = [postLocation.city, postLocation.region, postLocation.country].filter(p => p);
    postLocation.name = nameParts.join(', ');
  }
  
  let location = JobLocationModel.getById(postLocation.id);

  if (location) {
    if (!location.get('latitude')) {
      location.set('latitude', postLocation.latitude);
    }
    if (!location.get('longitude')) {
      location.set('longitude', postLocation.longitude);
    }
    return location;
  } else {
    location = new JobLocationModel(postLocation);
    JobLocationModel._all.push(location);
  }

  return location;
};

JobLocationModel.getById = (id) => {
  return JobLocationModel._all.find(jl => jl.get('id') == id);
}

JobLocationModel.fromMapLocation = (mapLocation) => {
  return JobLocationModel._all.find(jl => jl.get('id') == mapLocation.get('id'));
}

export default JobLocationModel;